import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from '@material-ui/pickers/views/Calendar/SlideTransition';

//    $circle-diameter: 30px;

// const useStyles = makeStyles((theme) => ({
//   dividedCircle: {
//     margin: '40px auto 0',
//     width: '40',
//     height: '40',
//     borderRadius: '100%',
//     '&:before,  &:after': {
//       content: '',
//       width: '20',
//       height: '40',
//     },
//     '&:before': {
//       float: 'left',
//       borderTopLeftRadius: '20',
//       borderBottomLeftRadius: '20',
//       background: '#f6303e',
//     },
//     '&:after': {
//       float: 'right',
//       borderTopRightRadius: '20',
//       borderBottomRightRadius: '20',
//       background: '#1ab15d',
//     },
//   },
// }));
// const useStyles = makeStyles((theme) => ({
//     dividedCircle : {
//         margin: '40px auto 0',
//         width: '$circle-diameter',
//         height: '$circle-diameter',
//         borderRadius: '100%',
//         '&:before,  &:after': {
//             content: '',
//             width: '$circle-diameter/2',
//             height: '$circle-diameter'
//         },
//         '&:before' : {
//             float: 'left',
//             borderTopLeftRadius: '$circle-diameter/2',
//             borderBottomLeftRadius: '$circle-diameter/2',
//             background: '#f6303e'
//         },
//         '&:after' : {
//             float: 'right',
//             borderTopRightRadius: '$circle-diameter/2',
//             borderBottomRightRadius: '$circle-diameter/2',
//             background: '#1ab15d'
//         }
//     }
// }));

//hsl(359 14% 30% / 1)

const toHsl = (companyName, incidentName, taskName) => {
  return (
    'hsl(' +
    decimalHash(companyName, 0, 360) +
    ' ' +
    decimalHash(incidentName, 50, 50) +
    '% ' +
    decimalHash(taskName, 35, 25) +
    '% / 1)'
  );
};

const decimalHash = (string, base, range) => {
  let sum = 0;
  for (let i = 0; i < string.length; i++)
    sum += ((i + 1) * string.codePointAt(i)) / (1 << 8);
  return (base + (sum % 1) * range).toFixed(0);
};

const hashCode = (str) => {
  // java String#hashCode
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};

const intToRGB = (i) => {
  var c = (i & 0x00ffffff).toString(16).toUpperCase();
  return '00000'.substring(0, 6 - c.length) + c;
};

const stringToColor = (str) => {
  return intToRGB(hashCode(str));
};

export const taskHsl = (item) => {
  return toHsl(item?.companyName || '', item?.incidentName || '', item?.taskName || '');
};

const Flag = ({ item }) => {
  const classes = useStyles();
  return (
    <span style={{ display: 'flex', marginTop: 3, marginRight: 3 }}>
      <div
        style={{
          width: 16,
          height: 16,
          marginTop: 1,
          backgroundColor: toHsl(item?.companyName, item?.incidentName, item?.taskName),
          borderRight: 'white solid 1px',
        }}
      />
      {/* <div
        style={{
          width: 8,
          height: 16,
          backgroundColor: stringToColor(item?.companyName || 'red'),
          borderRight: 'white solid 1px',
        }}
      />
      <div
        style={{
          width: 8,
          height: 16,
          backgroundColor: stringToColor(item?.incidentName || 'green'),
          borderRight: 'white solid 1px',
        }}
      />
      <div
        style={{
          width: 8,
          height: 16,
          backgroundColor: stringToColor(item?.taskName || 'blue'),
        }}
      /> */}
    </span>
  );
};
export default Flag;
